export class Search {
    private searchButtons: NodeListOf<HTMLElement>;
    private searchBox: HTMLElement;
    private readonly searchResultsPage: boolean;
    private searchInput: HTMLInputElement;
    private resetButton: HTMLButtonElement;

    constructor() {
        this.searchButtons = <NodeListOf<HTMLElement>>document.querySelectorAll("#Header .search-button");
        this.searchBox = document.querySelector(".search-box");
        this.searchResultsPage = this.searchBox.classList.contains("search-box--results");
        this.searchInput = <HTMLInputElement>document.getElementById("search-input");
        this.resetButton = this.searchBox.querySelector(".reset-button");

        this.searchButtons.forEach((button: HTMLButtonElement) => {
            button.addEventListener("click", () => {
                if (this.searchResultsPage) {
                    this.focusSearchInputField();
                    return;
                }

                let active = false;
                this.searchBox.classList.toggle("active");
                button.classList.toggle("active", active);

                this.focusSearchInputField();
            });
        });

        if (this.searchResultsPage == false) {
            this.addClickOutsideListener();
        }

        // manual reset - otherwise the reset button does not work with a value set
        this.resetButton.addEventListener("click", () => {
            this.searchInput.setAttribute("value", "");
        });
    }

    /* focus search input field (set cursor) */
    private focusSearchInputField() {
        this.searchInput.focus();
    }

    private addClickOutsideListener(): void {
        document.addEventListener("click", this.handleClickOutside.bind(this));
    }

    /* close search box on outside click */
    private handleClickOutside(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const isClickInside =
            Array.from(this.searchButtons).some((button) => button.contains(target)) || this.searchBox.contains(target);

        if (!isClickInside) {
            this.searchBox.classList.remove("active");
            this.searchButtons.forEach((button) => {
                button.classList.remove("active");
            });
        }
    }
}
